export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ee04f01f-8be7-4f50-a618-63ddd5c1385f';
export const MODAL_CLOSE_SEC = 2.5;
